import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { UPDATE_EMAIL_NOTIFICATIONS } from "../types";
import {
  updateEmailNotificationPending,
  updateEmailNotificationFulfilled,
  updateEmailNotificationRejected,
} from "../actions";

import { sendApiRequest, notifyError, notifySuccess } from "../../../actions";

import { ORGANIZATION_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "emailnotification/update",
  onSuccess: [
    updateEmailNotificationFulfilled,
    (response) => notifySuccess(ORGANIZATION_MESSAGES.SUCCESS),
  ],
  onError: [
    updateEmailNotificationRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const updateEmailNotificationEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_EMAIL_NOTIFICATIONS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(updateEmailNotificationPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      );
    })
  );

export default updateEmailNotificationEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/updateEmailNotificationEpic.js